import React from "react";
import { Grid } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Charts from "../Echarts";
import sales from "../../../utils/default/semic_data/sales";
import demand from "../../../utils/default/semic_data/demand";
import Chemistry from "../../../utils/default/semic_data/Chemistry";
import CMP from "../../../utils/default/semic_data/CMP";
import ElectronGas from "../../../utils/default/semic_data/ElectronGas";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridRoot: {
      textAlign: "center",
      color: "white",
      boxSizing: "border-box",
    },
    mid: {},
  })
);

const SemicRight: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid container direction="row" className={classes.gridRoot}>
      <Grid item xs={12} className={classes.mid}>
        <Charts option={demand} style={{ height: "30vh" }} />
      </Grid>
      <Grid item xs={12}>
        <Charts option={Chemistry} style={{ height: "30vh" }} />
      </Grid>
      <Grid item xs={6}>
        <Charts option={CMP} style={{ height: "30vh" }} />
      </Grid>
      <Grid item xs={6}>
        <Charts option={ElectronGas} style={{ height: "30vh" }} />
      </Grid>
    </Grid>
  );
};

export default SemicRight;
